const IPL_CLIENT_ID_MAP = {
  vrl: 1,
  guru: 2,
  ats: 3,
  apt: 4,
  vihira: 5,
  rcc: 6,
  xpress: 7,
  dpf: 8,
  jtsa: 9,
  shubham: 10,
  avr: 11,
  jkl: 12,
  gdala_log: 13,
  dgc: 14,
  std: 15,
  bst: 16,
  mcm: 17,
  mkl: 18,
  bgtc: 19,
  ase: 19,
  saral_eway: 20,
  agt: 21,
  arbuda: 22,
  atc: 23,
  zt: 24,
  pdm: 25,
  bafna: 26,
  bbac: 27,
  sgtc: 28,
};

const getIplClientId = () => {
  return IPL_CLIENT_ID_MAP[process.env.REACT_APP_CLIENT] ?? 1;
};

export { IPL_CLIENT_ID_MAP, getIplClientId };
